export const projects = [
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750511074/Projects/c271fe77-46ee-4799-9713-2cdfd7dcc071.png',
		title: 'Khata Manager',
		des: 'A personal finance tracker to manage daily expenses. Users can log, edit, and delete transactions, with a clear overview of their financial activity. Built with React and Context API for state management.',
		demo: '',
		live: 'https://khata-manager.netlify.app',
		gitHub: 'https://github.com/himrd95/khata-frontend',
		technologies: ['React', 'Context API', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750511111/Projects/0e01e775-4767-45df-8cad-eb64f6ba879d.png',
		title: 'Train Search App',
		des: 'A comprehensive portal for real-time Indian Railways information, built with React and TypeScript. This mobile-responsive app features live train tracking, PNR status checks, and seat availability by integrating multiple railway APIs. Styled with Tailwind CSS for a modern UI. 🚂✨',
		demo: '',
		live: 'https://train-search-app.netlify.app/',
		gitHub: 'https://github.com/himrd95/train-search-app',
		technologies: ['React', 'TypeScript', 'HTML', 'CSS'],
	},
	{
		img: '/ProjectImages/masai_refresh.png',
		title: 'Masai Refresh',
		des: 'A quiz application designed to help students prepare for technical interviews. It provides quizzes on preferred tech stacks and delivers a comprehensive performance analysis upon completion. Built with React and Redux for robust state management.',
		demo: '',
		live: 'https://refresh.masai.tech/quiz_topics',
		gitHub: 'https://github.com/masai-oss/Masai_Refresh.git',
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750575750/Projects/5f98715c-bb19-44fa-a24a-60c83aa438d1.png',
		title: 'Clone of BookMyShow',
		des: 'A functional clone of the BookMyShow website, allowing users to browse movies, select theaters, and book tickets for specific showtimes. It also features an events section for local happenings. Developed using React and Redux.',
		demo: '',
		live: 'https://bookmyshow-clone-masaischool.netlify.app/',
		gitHub: 'https://github.com/arshadalitalwar/bookmyshow.git',
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750576115/Projects/c5698b83-1602-4ec2-83e0-65bb9884214c.png',
		title: 'Todo App',
		des: 'A feature-rich To-Do application built with React and Redux. It supports adding, editing, and deleting tasks and sub-tasks, along with status updates, to help users manage their daily productivity.',
		demo: '',
		live: 'https://him-todo.netlify.app/',
		gitHub: 'https://github.com/himrd95/todo.git',
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750576089/Projects/2f5f116b-3f92-46f7-af20-7277f7038e25.png',
		title: 'Clone of Fitness Blender',
		des: 'A clone of the Fitness Blender website, providing features like user login, shopping cart, wishlists, and a calendar for scheduling workouts. Built with a focus on core e-commerce and user account functionalities using vanilla JavaScript.',
		demo: '',
		live: 'https://anshusagar.github.io/FitnessBlender/',
		gitHub: 'https://github.com/Anshusagar/FitnessBlender.git',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://res.cloudinary.com/dd246q5m8/image/upload/v1750575979/Projects/369f8878-36d7-4e3a-af7e-91cfa7e65d66.png',
		title: 'Mailchimp Clone',
		des: 'A static clone of the Mailchimp marketing platform\'s website. This project focused on recreating the landing, pricing, and resource pages with a high degree of visual fidelity using HTML and CSS.',
		demo: '',
		live: 'https://mandarsatam.github.io/Mailchimp-Clone/',
		gitHub: 'https://github.com/mandarsatam/Mailchimp-Clone',
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
];
